import Modal from '@src/common/Modal';
import React,{ useState,useEffect } from 'react';
import {InsuranceDate} from '@src/common/DatePicker';
import moment from 'moment';

interface DashboardFilterProps {
    show: boolean;
    handleClose: () => void;
    filterList: { value: number; label: string }[];
    filterType: string;
    onSuccess: (response: { applied_filter: boolean;}) => void;
}

const DashboardFilterPopup = ({show,handleClose,filterList,filterType,onSuccess}: DashboardFilterProps) => {

    const [appliedFilter, setAppliedFilter] = useState<any>({
        taskSummaryFilters: 'mtd',
        travelTaskSummaryFilters: 'mtd',
        pendingPaymentFilters: 'nd',
        raised_soa: null,
        to_date:null,
        from_date:null
    });

    const [errField, setErrField] = useState<any>({
        from_date : "",
        to_date: ""
    });

    const [showDateRange, setShowDateRange] = useState(false);

    // Check showDateRange state when the popup opens
    useEffect(() => {
        if (filterType === "taskSummaryFilters" && appliedFilter.taskSummaryFilters === "cdr") {
            setShowDateRange(true);
        } else if (filterType === "travelTaskSummaryFilters" && appliedFilter.travelTaskSummaryFilters === "cdr") {
            setShowDateRange(true);
        } else if (filterType === "pendingPaymentFilters" && appliedFilter.pendingPaymentFilters === "cdr") {
            setShowDateRange(true);
        } else {
            setShowDateRange(false);
        }
    }, [filterType, appliedFilter.taskSummaryFilters, appliedFilter.travelTaskSummaryFilters, appliedFilter.pendingPaymentFilters, show]);

    const handleFilterTypeChange = (value: any, key:string) => {
        if (key !== "raised_soa") {
            setShowDateRange(value === "cdr");
        }
        setAppliedFilter((prev: any) => ({
            ...prev,
            [key]: value,
            ...(value !== "cdr" && key !== "raised_soa" ? { from_date: null, to_date: null } : {}),
        }));
    }

    const handleDateChange = (field: string, date: Date) => {
        setAppliedFilter((prev: any) => {
            const formattedDate = moment(date).format("YYYY-MM-DD");

            if (field === "from_date") {
                // Reset to_date if from_date changes
                const toDate = prev.to_date && moment(prev.to_date);
                return {
                    ...prev,
                    from_date: formattedDate,
                    to_date: toDate && moment(formattedDate).isAfter(toDate) ? null : prev.to_date,
                };
            }

            if (field === "to_date") {
                return {
                    ...prev,
                    to_date: formattedDate,
                };
            }

            return { ...prev, [field]: formattedDate };
        });
    };

    const validateForm = () => {
        let formIsValid = true;
        setErrField({
            from_date : "",
            to_date: ""
        });
        if (appliedFilter[filterType] === "cdr") {
            // Validate from_date
            if (!appliedFilter.from_date) {
                setErrField((prevState: any) => ({
                    ...prevState,
                    from_date: "From Date is required.",
                }));
                formIsValid = false;
            }
            // Validate to_date
            if (!appliedFilter.to_date) {
                setErrField((prevState: any) => ({
                    ...prevState,
                    to_date: "To Date is required.",
                }));
                formIsValid = false;
            } else if (appliedFilter.from_date && appliedFilter.to_date < appliedFilter.from_date) {
                setErrField((prevState: any) => ({
                    ...prevState,
                    to_date: "To Date cannot be earlier than From Date.",
                }));
                formIsValid = false;
            }
        }
        return formIsValid;
    }

    const applyFilter = () => {
        if (validateForm()) {
            let appliedFilterPayload: any = {};
            if (filterType === "taskSummaryFilters") {
                appliedFilterPayload.taskSummaryFilters = appliedFilter.taskSummaryFilters;
                if (appliedFilter.taskSummaryFilters === "cdr") {
                    appliedFilterPayload.from_date = appliedFilter.from_date;
                    appliedFilterPayload.to_date = appliedFilter.to_date;
                }
            } else if (filterType === "travelTaskSummaryFilters") {
                appliedFilterPayload.travelTaskSummaryFilters = appliedFilter.travelTaskSummaryFilters;
                if (appliedFilter.travelTaskSummaryFilters === "cdr") {
                    appliedFilterPayload.from_date = appliedFilter.from_date;
                    appliedFilterPayload.to_date = appliedFilter.to_date;
                }
            } else if (filterType === "pendingPaymentFilters") {
                appliedFilterPayload.pendingPaymentFilters = appliedFilter.pendingPaymentFilters;
                if (appliedFilter.pendingPaymentFilters === "cdr") {
                    appliedFilterPayload.from_date = appliedFilter.from_date;
                    appliedFilterPayload.to_date = appliedFilter.to_date;
                }
                if(appliedFilter.raised_soa === 1 || appliedFilter.raised_soa === 0){
                    appliedFilterPayload.raised_soa = appliedFilter.raised_soa;
                }
            }
            onSuccess({ applied_filter: appliedFilterPayload });
            handleClose();
        }
    };

    return(
        <React.Fragment>
            <div className="model-outer upload-error-popup dashboard-filter-popup">
            <Modal show={show} handleClose={handleClose}>
                <div className="modal-body">
                    <div className='row'>
                        <div className='col-md-12 col-xs-12'>
                        {
                            filterType === "taskSummaryFilters" ?
                            <h2>Vehicle Task Summary filter By</h2> :
                            filterType === "travelTaskSummaryFilters" ?
                            <h2>Travel Task Summary filter By</h2> :
                            <h2>Pending Payments For</h2>
                        }
                        </div>
                        {filterList.map((filter,index) => (
                            <div key={index} className={`radio-btn ${(filterType === "taskSummaryFilters" || filterType === "travelTaskSummaryFilters") ? "col-md-12" : "col-md-6"}`}>
                                <fieldset key={filter.value} className="from-group radio-type-txt">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        id={`claim-type-${filter.value}`}
                                        type="radio"
                                        className="custom-control-input"
                                        name="claim_type"
                                        value={filter.value.toString()}
                                        onChange={() => handleFilterTypeChange(filter.value.toString(),filterType)}
                                        checked={appliedFilter[filterType] === filter.value}
                                    />
                                    <label className="custom-control-label">{filter.label}</label>
                                </div>
                                </fieldset>
                            </div>
                        ))}
                        {
                            filterType === "pendingPaymentFilters" &&
                            <div className='col-md-6'></div>
                        }
                        {
                            showDateRange &&
                            <>
                                <div className='col-md-6'>
                                    <fieldset>
                                        <div className={(appliedFilter && appliedFilter?.from_date)?`material animation-effect active-label`:`material animation-effect`}>
                                            <InsuranceDate
                                                onChange={(e: Date) => handleDateChange('from_date', e)}
                                                placeholder=""
                                                text="From Date"
                                                value={appliedFilter.from_date || ""}
                                            />
                                            {errField.from_date && (
                                                <span className="error-txt">
                                                    {errField['from_date'] || ""}
                                                </span>
                                            )}
                                        </div>
                                    </fieldset>
                                </div>
                                <div className='col-md-6'>
                                    <fieldset>
                                        <div className={(appliedFilter && appliedFilter?.to_date)?`material animation-effect active-label`:`material animation-effect`}>
                                            <InsuranceDate
                                                onChange={(e: Date) => handleDateChange('to_date', e)}
                                                placeholder=""
                                                text="To Date"
                                                value={appliedFilter.to_date || ""}
                                            />
                                            {errField.to_date && (
                                                <span className="error-txt">
                                                    {errField['to_date'] || ""}
                                                </span>
                                            )}
                                        </div>
                                    </fieldset>
                                </div>
                            </>
                        }
                        {
                            filterType === "pendingPaymentFilters" &&
                            <>
                                <div className='col-md-12'>
                                    <h2>Raised SOA</h2>
                                </div>
                                <div className="radio-btn col-md-3">
                                    <fieldset key='yes' className="from-group radio-type-txt">
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                id={`raised-soa-yes`}
                                                type="radio"
                                                className="custom-control-input"
                                                name="raised_soa"
                                                onChange={() => handleFilterTypeChange(1,'raised_soa')}
                                                checked={appliedFilter.raised_soa === 1}
                                            />
                                            <label className="custom-control-label">Yes</label>
                                        </div>
                                    </fieldset>
                                </div>
                                <div className="radio-btn col-md-3">
                                    <fieldset key='no' className="from-group radio-type-txt">
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                id={`raised-soa-no`}
                                                type="radio"
                                                className="custom-control-input"
                                                name="raised_soa"
                                                onChange={() => handleFilterTypeChange(0,'raised_soa')}
                                                checked={appliedFilter.raised_soa === 0}
                                            />
                                            <label className="custom-control-label">No</label>
                                        </div>
                                    </fieldset>
                                </div>
                            </>
                        }
                    </div>
                </div>
                <div className=''>
                    <button className='btn-primary btn-width-100' onClick={() => applyFilter()}>Submit</button>
                </div>
            </Modal>
            </div>
        </React.Fragment>
    );
}

export default DashboardFilterPopup;    